"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const quiz_container_1 = require("./quiz-container");
const fetch_result_renderer_1 = require("../../component/fetch-result-renderer");
const use_lazy_promise_1 = require("../../hook/use-lazy-promise");
const quiz_1 = require("../../network/quiz");
const log_view_layout_1 = require("../../component/log-view-layout");
const log_1 = require("../../model/log");
exports.QuizPage = (0, react_1.memo)(() => {
    const { id: passageId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { result: quizQuestionsResponse, status, error, executeWithVerify, } = (0, use_lazy_promise_1.useLazyPromise)(quiz_1.getQuestions);
    (0, react_1.useEffect)(() => {
        executeWithVerify(() => {
            if (!passageId) {
                throw new Error("Cannot find passage");
            }
            return [passageId];
        });
    }, [executeWithVerify, passageId]);
    const handleComplete = (0, react_1.useCallback)(() => {
        navigate(`/quiz-result/${passageId}`);
    }, [navigate, passageId]);
    return ((0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.QuizPage, children: (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: quizQuestionsResponse, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: { flex: 1, width: "100%" }, children: (data) => {
                return ((0, jsx_runtime_1.jsx)(quiz_container_1.QuizContainer, { passageId: passageId || "", onComplete: handleComplete, questions: data.questions.map((q) => q.question) }));
            } }) }));
});
exports.QuizPage.displayName = "QuizPage";
exports.default = exports.QuizPage;
